import APIService from '@/services/api-service'
const resource = '/fda'

class FdaService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public getJobs (AgentID: number) {
    return this.connector.get(`${resource}/${AgentID}/jobs`)
  }

  public getServices () {
    return this.connector.get(`${resource}/services`)
  }

  public getFdaRunningNumber () {
    return this.connector.get(`${resource}/running-no`)
  }

  public create (header: any, lines: any) {
    return this.connector.post(`${resource}/create`, { header: header, lines: lines })
  }

  public getFDADetails (fdaId: any) {
    return this.connector.get(`${resource}/details/${fdaId}`)
  }

  public update (header: any, lines: any) {
    return this.connector.put(`${resource}/update`, { header: header, lines: lines })
  }

  public deleteItemLine (fdaId: any, lineId: any) {
    return this.connector.delete(`${resource}/${fdaId}/line/${lineId}`)
  }

  public getJobDetails (jobId: any) {
    return this.connector.get(`${resource}/job-details/${jobId}`)
  }

  public getBankAccounts (companyId: any, currency:any) {
    return this.connector.get(`${resource}/${companyId}/${currency}/bank-accounts`)
  }

  public getBankAccount (accountId: any) {
    return this.connector.get(`${resource}/bank-account/${accountId}`)
  }
}

export default new FdaService()
